<template>
  <dataset-wrapper
    :type="defaultDatasetType"
    :mode="mode"
    :resource-id="resourceId"
  >
    <raster-download-stepper :default-type="defaultStepperType" />
  </dataset-wrapper>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import DatasetWrapper from '@/components/DatasetWrapper.vue';
import RasterDownloadStepper from '@/components/raster/RasterDownloadStepper.vue';


export default defineComponent({
  name: 'RasterView',
  components: {
    DatasetWrapper,
    RasterDownloadStepper,
  },
  props: {
    mode: { type: String, required: true },
    resourceId: { type: String, required: true },
    query: { type: Object as () => Record<string, string>, required: true },
  },
  setup(props) {
    const defaultDatasetType = computed(() => {
      return 'grid';
    });

    const defaultStepperType = computed(() => {
      const defaultType = props.query.defaultType;
      // get defaultType from query params if specified
      if (['timeseries', 'grid'].includes(defaultType)) {
        return defaultType;
      }
      // set timeseries as default defaultType for application
      return 'timeseries';
    });

    return {
      defaultDatasetType,
      defaultStepperType,
    };
  }  
})
</script>
